// extracted by mini-css-extract-plugin
export var NavigationContainer = "Navigation-module--NavigationContainer--oPIiB";
export var NavBox = "Navigation-module--NavBox--SvaNk";
export var NavImage = "Navigation-module--NavImage--Esjwu";
export var Color = "Navigation-module--Color--tEI0y";
export var Active = "Navigation-module--Active--pHu-I";